export const url = `${process.env.VUE_APP_SOCKET_HOST ||
  '192.168.1.38'}:${process.env.VUE_APP_SOCKET_PORT || '3000'}`;

export const turnCredentialsHost = `${process.env
  .VUE_APP_TURN_CREDENTIALS_HOST || 'http://192.168.1.38:8088'}`;

export const callsHost = `${process.env.VUE_APP_CALLS_HOST ||
  'https://api.160worldmeet.net'}`;

export const fileSizeLimit = `${process.env.VUE_APP_FILE_SIZE_LIMIT ||
  10485760}`;
